import AbstractApi, { type ClientConfig, type Headers } from '@/api/AbstractApi';
import type { TokenCookie } from '@/types/cookies';
import type { Nullable } from '@/types/utils';

type LoginRequestData = {
  username: string;
  password: string;
  type: string;
  cdcSynchronousFlows?: boolean;
  baseSite: string;
  grantEcoConsent?: boolean;
  recaptchaResponse?: string;
};

export default class AuthApi extends AbstractApi {
  constructor(config: ClientConfig) {
    super(config);
    this.basePath = `/api/storefront/auth`;
    this.baseUrl = useNuxtApp().$host;
  }

  login(
    username: string,
    password: string,
    type = 'basic',
    cdcSynchronousFlows = false,
    baseSite = 'FressnapfDE',
    grantEcoConsent = false,
    recaptchaResponse?: Nullable<string>,
  ) {
    const data: LoginRequestData = {
      username,
      password,
      type,
      cdcSynchronousFlows,
      baseSite,
      grantEcoConsent,
    };

    if (recaptchaResponse) {
      data.recaptchaResponse = recaptchaResponse;
    }

    const headers: Headers = {};

    // TODO: Add a comment explaining why we do this, and why it's important
    if (import.meta.dev) {
      headers['x-forwarded-for'] = '127.0.0.1';
    }

    return this.request(
      {
        method: 'post',
        url: '/login',
        data: {
          ...data,
        },
        headers,
      },
      false,
    );
  }

  logout(token?: Nullable<TokenCookie>) {
    return this.request({
      method: 'post',
      url: '/logout',
      data: {
        token,
      },
    });
  }

  anonymous() {
    return this.request({
      method: 'post',
      url: '/anonymous',
    });
  }

  refresh(refreshToken?: string, type = 'basic') {
    return this.request({
      method: 'post',
      url: '/refresh',
      data: {
        refreshToken,
        type,
      },
    });
  }
}
